import * as yup from 'yup';
import { APPARTMENT_NUM_INVALID_PATH, HOUSE_NUM_INVALID_PATH, INVALID_EMAIL_PATH, MOBILE_FORMAT_PATH, ONLY_DIGIT_PERMITED_PATH, REQUIRED_FIELD_PATH, STREET_NOT_SELECTED_PATH } from '../../errorMessages';
import { onlyNumbersRegExp, phoneRegExp } from '../../../helpers/regExps';
import { isNumeric } from '../../../helpers/validates/isNumeric';


export const yupObjectContactDetails = {
    streetId: yup.string()
        .notOneOf(['-1'], STREET_NOT_SELECTED_PATH)
        .required(REQUIRED_FIELD_PATH),
    house: yup.string()
        .test(
            "house",
            HOUSE_NUM_INVALID_PATH,
            (value) => {

                if (!value || !isNumeric(value)) {
                    return false;
                }

                let num = Number(value);

                return num > 0;
            }
        )
        .required(REQUIRED_FIELD_PATH)
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH),
    appartment: yup.string()

        .test(
            "appartment",
            APPARTMENT_NUM_INVALID_PATH,
            (value) => {

                if (!value) return true;

                if (!isNumeric(value)) {
                    return false;
                }

                let num = Number(value);

                return num > 0;
            }
        )
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH),
    email: yup.string()
        .email(INVALID_EMAIL_PATH)
        .required(REQUIRED_FIELD_PATH),
    mobile: yup.string()
        .required(REQUIRED_FIELD_PATH)
        .matches(phoneRegExp, MOBILE_FORMAT_PATH),
    phone: yup.string()
        .matches(phoneRegExp, MOBILE_FORMAT_PATH),
}